import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { RegisterUserBody, RegisterUserResponse } from "api/api/applicationsApi/types";
import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

interface ApiError {
  detail?: string;
  title?: string;
}

export const registerUser = createAsyncThunk<
  RegisterUserResponse,
  RegisterUserBody,
  { rejectValue: ApiError }
>(
  "applications/registerUser",
  async (body, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.registerUser(body);
      if (data.paymentUrl === null) {
        window.location.reload();
      } else if (data.paymentUrl) {
        window.location.href = data.paymentUrl;
      }
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ApiError>;
        const detail = axiosError.response?.data?.title;
        toast.error(detail ?? "Произошла ошибка");

        return rejectWithValue(
          axiosError.response?.data ?? { detail: "Unknown error" }
        );
      } else {
        toast.error("Что-то пошло не так... Попробуйте обновить страницу");
        return rejectWithValue({ detail: "Что-то пошло не так..." });
      }
    }
  }
);
